"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ErrorBoundary from "../../components/error_boundary";
import ExceptionSenderWrapper from "../exception_sender_wrapper";
import { ElementRoot } from "./element_root";
const FACTOR_INVOICE_ID_ATTR = "factor-invoice-id";
const CARRIER_INVOICE_ID_ATTR = "carrier-invoice-id";
const LOAD_STATE_ID_ATTR = "load-state-id";
const EMAIL_ID_ATTR = "email-id";
const TAG = "ht-exception-sender";
function invoiceKey(invoice) {
  switch (invoice.kind) {
    case "factor":
      return `factor-${invoice.factorInvoiceId}`;
    case "carrier":
      return `carrier-${invoice.carrierInvoiceId}-${invoice.loadStateId}`;
  }
}
function completedEventName(outcome) {
  switch (outcome) {
    case "sent":
      return "exception-sent";
    case "saved":
      return "exception-saved";
  }
}
class ExceptionSenderElement extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "root", new ElementRoot(this));
    __publicField(this, "queuedMessages", []);
  }
  static get observedAttributes() {
    return [
      FACTOR_INVOICE_ID_ATTR,
      CARRIER_INVOICE_ID_ATTR,
      LOAD_STATE_ID_ATTR,
      EMAIL_ID_ATTR
    ];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback() {
    this.renderFromAttributes();
  }
  disconnectedCallback() {
    this.root.unmountSoon();
  }
  invoiceFromAttributes() {
    const factorInvoiceId = this.getAttribute(FACTOR_INVOICE_ID_ATTR);
    if (factorInvoiceId) {
      return { kind: "factor", factorInvoiceId: parseInt(factorInvoiceId, 10) };
    }
    const carrierInvoiceId = this.getAttribute(CARRIER_INVOICE_ID_ATTR);
    const loadStateId = this.getAttribute(LOAD_STATE_ID_ATTR);
    if (carrierInvoiceId && loadStateId) {
      return {
        kind: "carrier",
        carrierInvoiceId: parseInt(carrierInvoiceId, 10),
        loadStateId: parseInt(loadStateId, 10)
      };
    }
    return null;
  }
  renderFromAttributes() {
    const invoice = this.invoiceFromAttributes();
    if (!invoice) return;
    const emailId = this.getAttribute(EMAIL_ID_ATTR);
    this.root.render(
      React.createElement(
        ErrorBoundary,
        { name: "exception-sender", resetKey: invoiceKey(invoice) },
        React.createElement(ExceptionSenderWrapper, {
          key: invoiceKey(invoice),
          invoice,
          emailId: emailId ? parseInt(emailId, 10) : void 0,
          queuedMessages: this.queuedMessages || [],
          onComplete: (outcome) => {
            this.dispatchEvent(
              new CustomEvent(completedEventName(outcome), { bubbles: true })
            );
          },
          onCancel: () => {
            this.dispatchEvent(
              new CustomEvent("exception-cancelled", { bubbles: true })
            );
          }
        })
      )
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, ExceptionSenderElement);
}
